import { render } from "./SessionTimeoutModal.vue?vue&type=template&id=07522172&scoped=true"
import script from "./SessionTimeoutModal.vue?vue&type=script&lang=js"
export * from "./SessionTimeoutModal.vue?vue&type=script&lang=js"

import "./SessionTimeoutModal.vue?vue&type=style&index=0&id=07522172&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07522172"]])

export default __exports__